import React from 'react';

import * as Styled from 'auth/styles/Card.style';
import * as Text from 'theme/components/Text.style';

type AuthCardProps = {
  heading: string;
  subheading?: string;
  children: React.ReactNode;
};

export default function AuthCard({
  heading,
  subheading,
  children,
}: AuthCardProps): React.ReactElement {
  return (
    <Styled.Card>
      <Styled.Header>
        <Text.H3>{heading}</Text.H3>
        {subheading && <Text.P2>{subheading}</Text.P2>}
      </Styled.Header>
      {children}
    </Styled.Card>
  );
}
